<div id="ChartLibContainer" class="anytype-column-chart" style="height:{{chartHeight}}px;"></div>